// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
import { QuoteRequestGroup } from '../Groups/QuoteRequestGroup';
export class QuotesRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_QUOTES_REQUEST, fieldSet);
    }
    addQuotesRequestGroup(tradableId, routeId) {
        const group = new QuoteRequestGroup();
        group.tradableId = tradableId;
        group.routeId = routeId;
        this.addGroup(group);
    }
}
